import React from "react";
import { Link } from "react-router-dom";
import styles from "./contact.module.css";
import TextHero from "../../COMPONENTS/TEXT_HERO";
import ContactForm from "../../COMPONENTS/FORM/CONTACT";
import ContactBlock from "../../COMPONENTS/CONTACT_BLOCK";
import useDocumentMeta from "../../UTILS/HOOKS/useDocumentMeta";

// Each audience has its own form, routed to the right KUR team.
const routes = [
  { label: "Sponsors & CROs", text: "Discuss a protocol with our sponsor team.", href: "/sponsors#contact" },
  { label: "Physicians", text: "Become a KUR investigator.", href: "/physicians#contact" },
  { label: "Patients", text: "Talk to a patient advocate about clinical trials.", href: "/patients#contact" },
];

const ContactPage = () => {
  useDocumentMeta({
    title: "Contact KUR Research",
    description:
      "Contact KUR Research by phone, email or our enquiry form. Sponsors, physicians and patients can reach the right KUR team directly.",
    path: "/contact",
  });

  return (
    <>
      <TextHero
        id="contact-hero-title"
        title={
          <>
            Get in touch with <em>KUR Research.</em>
          </>
        }
        lead="We invite you to connect with us by phone or email to explore how clinical research can elevate your patient care and expand your service offerings. Our team is happy to provide guidance and discuss the potential impact on your practice."
      >
        <nav className={styles.routes} aria-label="Contact by audience">
          {routes.map((r) => (
            <Link key={r.href} to={r.href} className={styles.route}>
              <span className={styles.routeLabel}>{r.label}</span>
              <span className={styles.routeText}>{r.text}</span>
              <span className={styles.routeArrow} aria-hidden="true">
                →
              </span>
            </Link>
          ))}
        </nav>
      </TextHero>

      <ContactBlock
        id="enquiry"
        showMap
        eyebrow="General enquiries"
        title="Send us a message."
        lead="For anything else, use the form and a member of the KUR team will follow up."
        details={[{ label: "Visit", value: "2425 Cedar Springs Rd\nDallas, Texas 75201" }]}
        note={
          <>
            For any compliance-related inquiries or concerns, please contact us at{" "}
            <a href="mailto:compliance@kurr.com">compliance@kurr.com</a>.
          </>
        }
      >
        <ContactForm />
      </ContactBlock>
    </>
  );
};

export default ContactPage;
